import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { IoMdClose } from "react-icons/io";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import { EVENT_LOCATIONS } from "../../../../utils/serviceTypesFromBudget";
import { useEffect, useRef } from "react";
import { ServiceValues } from "../../../../types/budget/service-item";

interface ApplicationPlaceModalProps {
  isOpen: boolean;
  onClose: () => void;
  serviceValues: ServiceValues;
  compareServiceValues: ServiceValues;
  onChange(descriptions: any, value: any): void;
  onConfirm(): void;
}

const ApplicationPlaceModal = ({
  onClose,
  isOpen,
  serviceValues,
  compareServiceValues,
  onChange,
  onConfirm,
}: ApplicationPlaceModalProps) => {
  const lastApplication = useRef<any | null>(null);

  useEffect(() => {
    if (serviceValues.serviceApplication && !lastApplication.current) {
      lastApplication.current = serviceValues.serviceApplication;
    }

    if (!serviceValues.serviceApplication) {
      lastApplication.current = "unset";
    }
  }, [serviceValues.serviceApplication]);

  const handleClose = () => {
    if (lastApplication.current) {
      if (lastApplication.current === "unset")
        onChange("", "serviceApplication");
      else onChange(lastApplication.current, "serviceApplication");
    }
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
    lastApplication.current = serviceValues.serviceApplication;
  };

  return (
    <Dialog onClose={handleClose} open={isOpen} fullWidth maxWidth={"sm"}>
      <DialogTitle sx={{ m: 0, px: 4, color: "#4B465C" }}>
        Local de aplicação
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <IoMdClose />
      </IconButton>
      <DialogContent sx={{ px: 4 }}>
        <Box display={"flex"} flexDirection={"column"} gap={2}>
          <Select
            size="small"
            fullWidth
            onChange={(e) => onChange(e.target.value, "serviceApplication")}
            value={serviceValues?.serviceApplication || "none"}
            defaultValue="none"
          >
            <MenuItem value="none" disabled>
              Clique para selecionar
            </MenuItem>
            {EVENT_LOCATIONS.map((el: any) => {
              return (
                <MenuItem value={el.value} key={el.value}>
                  {el.text}
                </MenuItem>
              );
            })}
          </Select>
          <FormHelperText>
            {
              EVENT_LOCATIONS.find(
                (el) => el.value === compareServiceValues?.serviceApplication
              )?.text
            }
          </FormHelperText>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 4, py: 3 }}>
        <Button onClick={handleClose} variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleConfirm}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApplicationPlaceModal;
